var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "850.39px",
    height: "850.39px",
    viewBox: "0 0 850.39 850.39",
    enableBackground: "new 0 0 850.39 850.39",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "body"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468.407,348.901c0,20.398-16.534,36.935-36.938,36.935c-20.398,0-36.937-16.537-36.937-36.935 c0-20.401,16.539-36.938,36.937-36.938C451.873,311.963,468.407,328.5,468.407,348.901z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.407,551.786c0,13.464-14.827,24.387-33.128,24.387h-11.96c-18.297,0-33.131-10.923-33.131-24.387V416.31 c0-13.47,14.834-24.388,33.131-24.388h11.96c18.301,0,33.128,10.918,33.128,24.388V551.786z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "left"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 357.2,
    y: 85.952,
    width: 12.182,
    height: 243.787
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1F24",
    points: "244.998,85.959 244.998,198.177 357.216,198.177  "
  })), /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F6DB0C",
    points: "357.2,198.18 357.208,85.962 244.99,85.954  "
  })), /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("path", {
    id: "leftHand",
    d: "M360.63,334.299c-8.159,0-14.773,6.615-14.773,14.773l0,66.053c0,8.161,6.614,14.775,14.774,14.775l0,0 c8.159,0,14.776-6.614,14.776-14.775v-66.053C375.406,340.914,368.789,334.299,360.63,334.299L360.63,334.299z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "right"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 494.199,
    y: 507.951,
    width: 12.182,
    height: 243.787
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ED1F24",
    points: "381.998,751.731 381.998,639.514 494.216,639.514  "
  })), /*#__PURE__*/React.createElement("g", null))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#F6DB0C",
    points: "494.2,639.512 494.208,751.729 381.99,751.737  "
  })), /*#__PURE__*/React.createElement("g", null)))), /*#__PURE__*/React.createElement("path", {
    id: "rightHand",
    d: "M497.958,404.776c-8.158,0-14.773,6.616-14.773,14.775v66.049c0,8.164,6.615,14.781,14.773,14.781l0,0 c8.163,0,14.777-6.617,14.777-14.781v-66.049C512.735,411.392,506.121,404.776,497.958,404.776L497.958,404.776z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD);
export default __webpack_public_path__ + "static/media/d.2be572abbc0ef97de55150c2252f2647.svg";
export { ForwardRef as ReactComponent };